import { j as s } from "../../../jsx-runtime-B3iL8JI7.js";
import { chipStyles as p } from "./Chip.styles.js";
import { leftIconOptions as x } from "./Chip.consts.js";
import o from "../Icon/Icon.js";
import f from "../../../tailwindConfig/bclTwMerge.js";
const y = ({
  className: r,
  label: e,
  color: t = "primary",
  showCloseIcon: l = !1,
  leftIcon: i,
  onClose: m,
  avatarUrl: a,
  ...c
}) => {
  const { base: n, colors: d } = p;
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "aria-label": e,
      className: f(n, d[t], r),
      ...c,
      children: [
        a && /* @__PURE__ */ s.jsx(
          "img",
          {
            src: a,
            alt: `${e}'s avatar`,
            className: "mr-1 size-3 rounded-full"
          }
        ),
        i && /* @__PURE__ */ s.jsx(
          o,
          {
            icon: x[i],
            className: "mr-1 size-3",
            "data-testid": "left-icon"
          }
        ),
        /* @__PURE__ */ s.jsx(
          "p",
          {
            className: "mt-[2px] flex text-caption-xs font-medium",
            id: `chip-label-${e}`,
            children: e
          }
        ),
        l && /* @__PURE__ */ s.jsx(
          "button",
          {
            className: `pointer-events-auto ml-1 flex size-3 items-center p-0 ${t === "disabled" ? "cursor-not-allowed" : ""}`,
            onClick: m,
            disabled: t === "disabled",
            "aria-label": `Remove ${e}`,
            "data-testid": "close-button",
            children: /* @__PURE__ */ s.jsx(o, { icon: "close", className: "size-3" })
          }
        )
      ]
    }
  );
};
export {
  y as default
};
